<template>
  <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow solicitud-permiso-disfrute">
    <v-row>
      <v-col
        cols="12"
        class="d-flex justify-center align-center solicitudes-permisos-loading"
        v-if="loading"
      >
        <v-progress-circular indeterminate color="primary" size="100" />
      </v-col>

      <template v-else>
        <v-col cols="12" v-if="isEditing && folioSolicitud">
          <div class="folio-info-box mb-3">
            Folio de la solicitud: {{ folioSolicitud }}
          </div>
        </v-col>

        <v-col cols="12">
          <div class="d-flex flex-column flex-sm-row justify-space-between align-sm-center mb-6">
            <div>
              <template v-if="isEditing">
                <h1 class="text-h5 font-weight-bold mb-1">Corregir solicitud</h1>
                <p class="mb-0 text-body-2 text-secondary">
                  Actualiza los datos. Después genera el formato, fírmalo y cárgalo para enviarla a validación.
                </p>
              </template>
              <template v-else>
                <h1 class="text-h5 font-weight-bold mb-1">Solicitud de permiso / días de disfrute</h1>
                <p class="mb-0 text-body-2 text-secondary">
                  Selecciona un concepto y captura las fechas de disfrute
                  <template v-if="!periodoPermiteSolicitudRetroactiva">({{ textoAnticipacion }})</template>.
                </p>
              </template>
            </div>
            <v-btn class="mt-4 mt-sm-0" color="secondary" outlined @click="onRegresar()">
              <v-icon left>mdi-arrow-left</v-icon>
              Regresar
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" v-if="motivo_rechazo">
          <v-card outlined class="section-card mb-4">
            <v-card-text>
              <div class="font-weight-bold">MOTIVO DEL RECHAZO:</div>
              <div class="text-danger">{{ motivo_rechazo }}</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card outlined class="section-card">
            <v-card-title class="section-card__title">Concepto</v-card-title>
            <v-card-text>
              <v-alert
                v-if="!tiposDisponibles.length"
                type="warning"
                dense
                outlined
                class="mb-0"
              >
                NO HAY PERIODOS ACTIVOS.
              </v-alert>
              <v-radio-group
                v-else
                v-model="form.id_tipo_permiso"
                column
                hide-details
                :disabled="isEditing"
              >
                <v-radio
                  v-for="tipo in tiposDisponibles"
                  :key="tipo.id"
                  :label="tipo.descripcion"
                  :value="Number(tipo.id)"
                  :disabled="isEditing"
                />
              </v-radio-group>
              <v-alert
                v-if="mensajeAntiguedad"
                type="warning"
                dense
                outlined
                class="mt-3 mb-0"
              >
                {{ mensajeAntiguedad }}
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="form.id_tipo_permiso">
          <v-card outlined class="section-card">
            <v-card-title class="section-card__title">Datos del disfrute</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12" v-if="requierePeriodo">
                  <v-select
                    v-model="form.id_periodo_permiso_disfrute"
                    :items="periodosFiltrados"
                    item-text="descripcion"
                    item-value="id"
                    label="Periodo correspondiente *"
                    outlined
                    dense
                    :disabled="isEditing"
                    :no-data-text="'No hay periodos disponibles para este tipo'"
                  />
                  <v-alert
                    v-if="periodoSeleccionado && Number(periodoSeleccionado.dias_ampliados) > 0"
                    type="success"
                    dense
                    text
                    class="mt-2 mb-0"
                  >
                    Recursos Humanos te amplió este periodo vacacional con {{ periodoSeleccionado.dias_ampliados }} día(s) adicional(es).
                  </v-alert>
                  <v-alert
                    v-if="periodoPermiteSolicitudRetroactiva"
                    type="info"
                    dense
                    text
                    class="mt-2 mb-0"
                  >
                    Recursos Humanos te autorizó solicitar fechas pasadas dentro de este periodo vacacional.
                  </v-alert>
                  <p
                    v-if="diasDisponiblesPeriodoSeleccionado !== null"
                    class="text-body-2 mt-2 mb-0"
                  >
                    Días disponibles de este periodo:
                    <strong>{{ diasDisponiblesPeriodoSeleccionado }}</strong>
                  </p>
                </v-col>

                <template v-if="mostrarCamposDisfrute">
                <v-col cols="12" class="pb-0">
                  <div class="d-flex flex-wrap align-center inhabiles-leyenda">
                    <span class="text-caption mr-4 mb-1">
                      <span class="inhabil-muestra inhabil-muestra--ley" /> Día inhábil por ley
                    </span>
                    <span class="text-caption mr-4 mb-1">
                      <span class="inhabil-muestra inhabil-muestra--costumbres" /> Día inhábil por usos y costumbres
                    </span>
                    <span class="text-caption mr-4 mb-1">
                      <span class="inhabil-muestra inhabil-muestra--economicos" /> Días económicos solicitados
                    </span>
                    <span class="text-caption mr-4 mb-1">
                      <span class="inhabil-muestra inhabil-muestra--extraordinarios" /> Extraordinarios solicitados
                    </span>
                    <span class="text-caption mr-4 mb-1">
                      <span class="inhabil-muestra inhabil-muestra--vacaciones" /> Vacaciones solicitadas
                    </span>
                    <span class="text-caption mb-1">
                      <span class="inhabil-muestra inhabil-muestra--anios-servicio" /> Años de servicio solicitados
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    v-model="menuFechaInicio"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="fecha-picker-menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.fecha_inicio_disfrute"
                        label="Fecha inicio disfrute *"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        @focus="quitarFocoAlAbrir"
                      />
                    </template>
                    <v-date-picker
                      v-model="form.fecha_inicio_disfrute"
                      :min="fechaInicioMinPeriodo"
                      :allowed-dates="esFechaInicioPermitida"
                      :events="esDiaConEventoCalendario"
                      :event-color="colorEventoCalendario"
                      no-title
                      scrollable
                      @input="menuFechaInicio = false"
                    />
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-menu
                    v-model="menuFechaFin"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="fecha-picker-menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.fecha_fin_disfrute"
                        label="Fecha fin disfrute *"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        @focus="quitarFocoAlAbrir"
                      />
                    </template>
                    <v-date-picker
                      v-model="form.fecha_fin_disfrute"
                      :min="form.fecha_inicio_disfrute || fechaInicioMinPeriodo"
                      :max="fechaFinMaxPeriodo"
                      :allowed-dates="esFechaFinPermitida"
                      :events="esDiaConEventoCalendario"
                      :event-color="colorEventoCalendario"
                      no-title
                      scrollable
                      @input="menuFechaFin = false"
                    />
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-menu
                    v-model="menuFechaReincorporacion"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="fecha-picker-menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.fecha_reincorporacion"
                        label="Fecha de reincorporación *"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        @focus="quitarFocoAlAbrir"
                      />
                    </template>
                    <v-date-picker
                      v-model="form.fecha_reincorporacion"
                      :min="fechaReincorporacionMin"
                      :allowed-dates="esDiaHabilPermitido"
                      :events="esDiaConEventoCalendario"
                      :event-color="colorEventoCalendario"
                      no-title
                      scrollable
                      @input="menuFechaReincorporacion = false"
                    />
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    :value="anioReferenciaMostrado"
                    type="number"
                    label="Año de referencia *"
                    outlined
                    dense
                    readonly
                    class="campo-solo-lectura"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    :value="diasHabilesMostrado"
                    label="Días hábiles solicitados"
                    outlined
                    dense
                    readonly
                    class="campo-solo-lectura"
                    hint="Calculado con fines de semana e inhábiles del calendario"
                    persistent-hint
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :value="correoActualMostrado"
                    label="Correo actual"
                    outlined
                    dense
                    readonly
                    class="campo-solo-lectura"
                    hint="Correo que se utilizará para enviar notificaciones sobre el estatus de tu solicitud."
                    persistent-hint
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-switch
                    v-model="actualizarCorreo"
                    label="Actualizar correo"
                    dense
                    hide-details
                    class="mt-0"
                  />
                </v-col>

                <v-col cols="12" md="6" v-if="actualizarCorreo">
                  <v-text-field
                    v-model="correoNuevo"
                    label="Nuevo correo *"
                    outlined
                    dense
                    type="email"
                    autocomplete="email"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-if="unidadGuardada"
                    :value="unidadGuardada.texto"
                    label="Unidad"
                    outlined
                    dense
                    readonly
                    class="campo-solo-lectura"
                    hint="Unidad guardada en esta solicitud."
                    persistent-hint
                  />
                  <v-select
                    v-else-if="requiereElegirUnidadComision"
                    v-model="form.id_unidad"
                    :items="unidadesComision"
                    item-text="unidad"
                    item-value="id_unidad"
                    label="Unidad *"
                    outlined
                    dense
                    no-data-text="No hay unidades activas en tu zona de adscripción"
                  />
                  <v-text-field
                    v-else
                    :value="unidadComisionMostrada"
                    label="Unidad"
                    outlined
                    dense
                    readonly
                    class="campo-solo-lectura"
                    :hint="unidadesComision.length === 0 ? 'No hay unidades activas en tu zona de adscripción.' : 'Unidad asignada.'"
                    persistent-hint
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="form.observaciones"
                    label="Observaciones"
                    outlined
                    dense
                    rows="3"
                    @input="form.observaciones = (form.observaciones || '').toUpperCase()"
                  />
                </v-col>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" class="d-flex justify-end" v-if="mostrarCamposDisfrute">
          <v-btn
            color="primary"
            large
            :disabled="guardandoSolicitud"
            :loading="guardandoSolicitud"
            @click="isEditing ? submitUpdateRequest() : submitRequest()"
          >
            <v-icon left>{{ isEditing ? 'mdi-content-save-edit-outline' : 'mdi-content-save-outline' }}</v-icon>
            {{ isEditing ? 'Guardar corrección' : 'Guardar solicitud' }}
          </v-btn>
        </v-col>
      </template>
    </v-row>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3500">
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { obtenerDiasDisponiblesPeriodo } from '@/utils/saldosPermisoDisfrute'

const crearFormularioVacio = () => ({
  id_tipo_permiso: null,
  id_periodo_permiso_disfrute: null,
  anio_referencia: null,
  fecha_inicio_disfrute: '',
  fecha_fin_disfrute: '',
  fecha_reincorporacion: '',
  observaciones: '',
  id_zona_adscripcion: null,
  id_unidad: null,
})

export default {
  props: {
    datos_empleado: {
      type: Object,
      default: () => ({}),
    },
    id_solicitud: {
      type: [String, Number],
      default: null,
    },
    datos_solicitud_editar: {
      type: Object,
      default: null,
    },
    motivo_rechazo: {
      type: String,
      default: null,
    },
    catalogos: {
      type: Object,
      default: () => ({
        tipos: [],
        periodos: [],
        inhabiles: [],
        dias_solicitados: [],
        anio: new Date().getFullYear(),
      }),
    },
  },
  data () {
    const catalogosIniciales = this.catalogos || {}
    const anio = catalogosIniciales.anio || new Date().getFullYear()
    const catalogosPrecargados = Array.isArray(catalogosIniciales.tipos) && catalogosIniciales.tipos.length > 0
    return {
      loading: !catalogosPrecargados,
      guardandoSolicitud: false,
      isHydratingEditData: false,
      folioSolicitud: null,
      catalogosLocales: {
        tipos: catalogosIniciales.tipos || [],
        periodos: catalogosIniciales.periodos || [],
        inhabiles: catalogosIniciales.inhabiles || [],
        dias_solicitados: catalogosIniciales.dias_solicitados || [],
        anio,
      },
      form: crearFormularioVacio(),
      menuFechaInicio: false,
      menuFechaFin: false,
      menuFechaReincorporacion: false,
      snackbar: {
        show: false,
        text: '',
        color: 'success',
      },
      correoActual: '',
      actualizarCorreo: false,
      correoNuevo: '',
    }
  },
  computed: {
    ...mapState(['user']),
    correoActualMostrado () {
      return this.correoActual || ''
    },
    isEditing () {
      return Boolean(this.id_solicitud && this.datos_solicitud_editar)
    },
    tiposDisponibles () {
      const tipos = this.catalogosLocales.tipos || []
      const visibles = tipos.filter((tipo) => this.tipoEsVisible(tipo))

      if (this.isEditing && this.form.id_tipo_permiso) {
        const idActual = Number(this.form.id_tipo_permiso)
        const yaIncluido = visibles.some((t) => Number(t.id) === idActual)
        if (!yaIncluido) {
          const tipoActual = tipos.find((t) => Number(t.id) === idActual)
          if (tipoActual) {
            return [...visibles, tipoActual]
          }
        }
      }

      return visibles
    },
    tipoSeleccionado () {
      return this.tiposDisponibles.find((t) => Number(t.id) === Number(this.form.id_tipo_permiso)) || null
    },
    requierePeriodo () {
      return this.tipoSeleccionado && Number(this.tipoSeleccionado.requiere_periodo) === 1
    },
    mostrarCamposDisfrute () {
      if (!this.form.id_tipo_permiso) {
        return false
      }
      if (this.requierePeriodo) {
        return Boolean(this.form.id_periodo_permiso_disfrute)
      }
      return true
    },
    periodosFiltrados () {
      const idTipo = Number(this.form.id_tipo_permiso)
      const idPeriodoActual = this.isEditing && this.form.id_periodo_permiso_disfrute
        ? Number(this.form.id_periodo_permiso_disfrute)
        : null
      const periodosBase = this.periodosConPeriodoEdicion
      return periodosBase
        .filter((p) => {
          if (Number(p.id_tipo_permiso) !== idTipo) {
            return false
          }
          if (idPeriodoActual && Number(p.id) === idPeriodoActual) {
            return true
          }
          return Number(p.dias_disponibles) > 0 && Number(p.saldo_activo) !== 0
        })
        .map((p) => ({
          ...p,
          id: Number(p.id),
          id_tipo_permiso: Number(p.id_tipo_permiso),
          descripcion: this.etiquetaPeriodo(p),
        }))
    },
    /**
     * Catálogo de periodos + periodo de la solicitud en edición (por si el API
     * no lo trajo o el select falla por id string vs number).
     */
    periodosConPeriodoEdicion () {
      const periodos = [...(this.catalogosLocales.periodos || [])]
      const d = this.datos_solicitud_editar
      if (!this.isEditing || !d || !d.id_periodo_permiso_disfrute) {
        return periodos
      }
      const idPeriodo = Number(d.id_periodo_permiso_disfrute)
      if (!idPeriodo || periodos.some((p) => Number(p.id) === idPeriodo)) {
        return periodos
      }
      const periodoDetalle = d.periodo || null
      periodos.push({
        id: idPeriodo,
        id_tipo_permiso: Number(d.id_tipo_permiso) || (periodoDetalle && Number(periodoDetalle.id_tipo_permiso)) || null,
        anio: periodoDetalle && periodoDetalle.anio != null
          ? Number(periodoDetalle.anio)
          : (d.anio_referencia ? Number(d.anio_referencia) : null),
        descripcion: (periodoDetalle && periodoDetalle.descripcion)
          || d.periodo_descripcion
          || 'Periodo de la solicitud',
        fecha_inicio: (periodoDetalle && periodoDetalle.fecha_inicio) || null,
        fecha_fin: (periodoDetalle && periodoDetalle.fecha_fin) || null,
        fecha_fin_efectiva: (periodoDetalle && periodoDetalle.fecha_fin_efectiva)
          || (periodoDetalle && periodoDetalle.fecha_fin)
          || null,
        tiene_ampliacion: periodoDetalle ? Number(periodoDetalle.tiene_ampliacion) || 0 : 0,
        dias_disponibles: 1,
        saldo_activo: 1,
      })
      return periodos
    },
    periodoSeleccionado () {
      if (!this.form.id_periodo_permiso_disfrute) {
        return null
      }
      return this.periodosFiltrados.find(
        (p) => Number(p.id) === Number(this.form.id_periodo_permiso_disfrute)
      ) || this.periodosConPeriodoEdicion.find(
        (p) => Number(p.id) === Number(this.form.id_periodo_permiso_disfrute)
      ) || null
    },
    diasDisponiblesPeriodoSeleccionado () {
      return obtenerDiasDisponiblesPeriodo(this.periodoSeleccionado)
    },
    periodoPermiteSolicitudRetroactiva () {
      return this.periodoSeleccionado
        && Number(this.periodoSeleccionado.permitir_solicitud_retroactiva) === 1
    },
    textoAnticipacion () {
      return 'mínimo 3 días naturales de anticipación'
    },
    fechaInicioMinPeriodo () {
      if (!this.periodoSeleccionado || !this.periodoSeleccionado.fecha_inicio) {
        return undefined
      }
      return String(this.periodoSeleccionado.fecha_inicio).substring(0, 10)
    },
    fechaFinMaxPeriodo () {
      if (!this.periodoSeleccionado) {
        return undefined
      }
      const finEfectiva = this.periodoSeleccionado.fecha_fin_efectiva
        || this.periodoSeleccionado.fecha_fin
      if (!finEfectiva) {
        return undefined
      }
      return String(finEfectiva).substring(0, 10)
    },
    esEventualJubilado () {
      if (!this.datos_empleado) {
        return false
      }
      return Number(this.datos_empleado.id_tipo_trabajador) === 3
        && this.datos_empleado.tipo_eventual === 'jubilado'
    },
    esElegibleDiasEconomicos () {
      if (!this.datos_empleado) {
        return false
      }
      const tipo = Number(this.datos_empleado.id_tipo_trabajador)
      return tipo === 1 || tipo === 2 || this.esEventualJubilado
    },
    // Configuración por tipo de permiso y categoría de empleado (API nuevo); null con el API anterior
    tiposPermisoHabilitados () {
      const lista = this.datos_empleado && this.datos_empleado.tipos_permiso_habilitados
      return Array.isArray(lista) ? lista.map(Number) : null
    },
    tieneAntiguedad6Meses () {
      return this.datos_empleado && this.datos_empleado.ya_tiene_antiguedad_6_meses === true
    },
    esElegibleCuatrimestre () {
      if (!this.datos_empleado) {
        return false
      }
      return this.datos_empleado.elegible_cuatrimestre === true
        || this.datos_empleado.elegible_extraordinarios === true
    },
    esElegibleAniosServicio () {
      if (!this.datos_empleado) {
        return false
      }
      return this.datos_empleado.elegible_anios_servicio === true
    },
    mapInhabilesTipos () {
      const map = {}
      ;(this.catalogosLocales.inhabiles || []).forEach((item) => {
        if (item && item.fecha) {
          map[String(item.fecha).substring(0, 10)] = item.tipo || 'ley'
        }
      })
      return map
    },
    mapDiasSolicitadosTipos () {
      const map = {}
      const excluirId = this.isEditing && this.id_solicitud
        ? Number(this.id_solicitud)
        : null

      ;(this.catalogosLocales.dias_solicitados || []).forEach((item) => {
        if (!item || !item.fecha_inicio_disfrute || !item.fecha_fin_disfrute) {
          return
        }
        if (excluirId && Number(item.id_solicitud) === excluirId) {
          return
        }

        const tipo = item.tipo_permiso_clave || item.tipo_clave || ''
        const inicio = new Date(String(item.fecha_inicio_disfrute).substring(0, 10) + 'T00:00:00')
        const fin = new Date(String(item.fecha_fin_disfrute).substring(0, 10) + 'T00:00:00')
        if (Number.isNaN(inicio.getTime()) || Number.isNaN(fin.getTime()) || fin < inicio) {
          return
        }

        const cursor = new Date(inicio)
        while (cursor <= fin) {
          map[this.formatYmd(cursor)] = tipo
          cursor.setDate(cursor.getDate() + 1)
        }
      })

      return map
    },
    mensajeAntiguedad () {
      if (!this.tieneAntiguedad6Meses) {
        return 'Para vacaciones y días económicos se requiere antigüedad mínima de 6 meses.'
      }
      return null
    },
    setInhabiles () {
      const set = {}
      ;(this.catalogosLocales.inhabiles || []).forEach((item) => {
        if (item && item.fecha) {
          set[String(item.fecha).substring(0, 10)] = true
        }
      })
      return set
    },
    numDiasHabiles () {
      return this.contarDiasHabiles(
        this.form.fecha_inicio_disfrute,
        this.form.fecha_fin_disfrute
      )
    },
    anioReferenciaMostrado () {
      return this.form.anio_referencia != null && this.form.anio_referencia !== ''
        ? this.form.anio_referencia
        : ''
    },
    diasHabilesMostrado () {
      if (!this.form.fecha_inicio_disfrute || !this.form.fecha_fin_disfrute) {
        return ''
      }
      return this.numDiasHabiles
    },
    zonasComision () {
      // zonas_unidad_solicitud: comisión vigente o, sin comisión, la zona del empleado (API nuevo)
      const datos = this.datos_empleado || {}
      const lista = Array.isArray(datos.zonas_unidad_solicitud)
        ? datos.zonas_unidad_solicitud
        : (Array.isArray(datos.zonas_comision_vigente) ? datos.zonas_comision_vigente : [])
      return lista.map((zona) => ({
        id_zona_adscripcion: Number(zona.id_zona_adscripcion),
        zona_adscripcion: zona.zona_adscripcion,
        unidades: Array.isArray(zona.unidades)
          ? zona.unidades.map((unidad) => ({
            id_unidad: Number(unidad.id_unidad),
            unidad: unidad.unidad || '',
          })).filter((unidad) => unidad.id_unidad > 0)
          : [],
      }))
    },
    zonaGuardada () {
      if (!this.isEditing || !this.datos_solicitud_editar) {
        return null
      }
      const id = Number(this.datos_solicitud_editar.id_zona_adscripcion) || null
      if (!id) {
        return null
      }
      const deLista = this.zonasComision.find((item) => item.id_zona_adscripcion === id)
      return {
        id,
        texto: (this.datos_solicitud_editar.zona_adscripcion_comision || (deLista && deLista.zona_adscripcion) || ''),
      }
    },
    unidadesComision () {
      const vistas = {}
      const lista = []
      this.zonasComision.forEach((zona) => {
        (zona.unidades || []).forEach((unidad) => {
          if (vistas[unidad.id_unidad]) {
            return
          }
          vistas[unidad.id_unidad] = true
          lista.push({
            id_unidad: unidad.id_unidad,
            unidad: unidad.unidad,
            id_zona_adscripcion: zona.id_zona_adscripcion,
          })
        })
      })
      return lista
    },
    requiereElegirUnidadComision () {
      return !this.unidadGuardada && this.unidadesComision.length > 1
    },
    unidadGuardada () {
      if (!this.isEditing || !this.datos_solicitud_editar) {
        return null
      }
      const id = Number(this.datos_solicitud_editar.id_unidad) || null
      if (!id) {
        return null
      }
      const deLista = this.unidadesComision.find((item) => item.id_unidad === id)
      return {
        id,
        texto: (this.datos_solicitud_editar.unidad_adscripcion_comision || (deLista && deLista.unidad) || ''),
      }
    },
    unidadComisionMostrada () {
      const id = Number(this.form.id_unidad)
      const unidad = this.unidadesComision.find((item) => item.id_unidad === id)
      return unidad ? unidad.unidad : ''
    },
    fechaReincorporacionMin () {
      if (!this.form.fecha_fin_disfrute) {
        return undefined
      }
      const siguiente = new Date(this.form.fecha_fin_disfrute + 'T00:00:00')
      if (Number.isNaN(siguiente.getTime())) {
        return undefined
      }
      siguiente.setDate(siguiente.getDate() + 1)
      return this.formatYmd(siguiente)
    },
  },
  watch: {
    'form.id_tipo_permiso' (nuevoTipo) {
      if (this.isHydratingEditData) {
        return
      }
      this.form.id_periodo_permiso_disfrute = null
      this.limpiarCamposDisfrute()
    },
    'form.id_periodo_permiso_disfrute' () {
      if (this.isHydratingEditData) {
        return
      }
      this.limpiarCamposDisfrute()
    },
    'form.fecha_inicio_disfrute' (nuevaFechaInicio, fechaAnterior) {
      if (this.isHydratingEditData) {
        return
      }
      if (!nuevaFechaInicio) {
        this.form.anio_referencia = null
        this.limpiarCamposDependientesDeFechaInicio()
        return
      }
      if (fechaAnterior !== nuevaFechaInicio) {
        this.limpiarCamposDependientesDeFechaInicio()
      }
      this.sincronizarAnioDesdeFechaInicio(nuevaFechaInicio)
    },
    'form.fecha_fin_disfrute' (nuevaFechaFin) {
      if (this.isHydratingEditData) {
        return
      }
      if (!nuevaFechaFin || !this.form.fecha_reincorporacion) {
        return
      }
      if (this.form.fecha_reincorporacion <= nuevaFechaFin) {
        this.form.fecha_reincorporacion = ''
      }
    },
    actualizarCorreo (valor) {
      if (!valor) {
        this.correoNuevo = ''
      }
    },
    datos_empleado: {
      handler (datos) {
        const correo = datos && datos.correo ? String(datos.correo).trim() : ''
        this.correoActual = correo
        this.aplicarZonaComision()
      },
      deep: true,
      immediate: true,
    },
    'form.id_unidad' () {
      if (this.isHydratingEditData) {
        return
      }
      this.aplicarZonaDesdeUnidad()
    },
  },
  async created () {
    if (this.isEditing) {
      this.loading = true
    }
    try {
      if (this.isEditing && this.datos_solicitud_editar && this.datos_solicitud_editar.anio_referencia) {
        await this.cargarCatalogos(Number(this.datos_solicitud_editar.anio_referencia))
      } else if (!(this.catalogosLocales.tipos || []).length) {
        await this.asegurarCatalogos()
      }
      this.inicializarDatosEdicion()
      await this.cargarCorreoEmpleado()
    } finally {
      this.loading = false
    }
  },
  methods: {
    etiquetaPeriodo (periodo) {
      if (!periodo) {
        return ''
      }
      const inicio = periodo.fecha_inicio
        ? String(periodo.fecha_inicio).substring(0, 10)
        : null
      const finEfectiva = periodo.fecha_fin_efectiva || periodo.fecha_fin
      const fin = finEfectiva ? String(finEfectiva).substring(0, 10) : null
      let etiqueta = periodo.descripcion || 'Periodo'
      if (inicio && fin) {
        etiqueta += ` (${inicio} - ${fin})`
      }
      if (Number(periodo.dias_ampliados) > 0) {
        etiqueta += ` · +${periodo.dias_ampliados} DÍAS`
      }
      return etiqueta
    },
    puedeUsarTipo (tipo) {
      if (!tipo) return false
      if (this.tiposPermisoHabilitados) {
        if (!this.tiposPermisoHabilitados.includes(Number(tipo.id))) {
          return false
        }
      } else if (this.esEventualJubilado && tipo.clave !== 'dias_economicos') {
        return false
      }
      // Antigüedad mínima por tipo (meses, catálogo de reglas); con el API anterior, 6 meses en vacaciones y días económicos
      const antiguedadCumplida = Array.isArray(this.datos_empleado && this.datos_empleado.tipos_permiso_antiguedad_cumplida)
        ? this.datos_empleado.tipos_permiso_antiguedad_cumplida.map(Number).includes(Number(tipo.id))
        : null
      if (antiguedadCumplida === false) {
        return false
      }
      if (tipo.clave === 'dias_economicos') {
        return (this.tiposPermisoHabilitados ? true : this.esElegibleDiasEconomicos)
          && (antiguedadCumplida === true || this.tieneAntiguedad6Meses)
      }
      if (tipo.clave === 'vacaciones') {
        return antiguedadCumplida === true || this.tieneAntiguedad6Meses
      }
      if (tipo.clave === 'cuatrimestre') {
        return this.esElegibleCuatrimestre
      }
      if (tipo.clave === 'anios_servicio') {
        return this.esElegibleAniosServicio
      }
      return true
    },
    tipoEsVisible (tipo) {
      if (!this.puedeUsarTipo(tipo)) {
        return false
      }
      if (Number(tipo.requiere_periodo) === 1) {
        const idPeriodoActual = this.isEditing && this.form.id_periodo_permiso_disfrute
          ? Number(this.form.id_periodo_permiso_disfrute)
          : null
        const periodos = this.periodosConPeriodoEdicion.filter((p) => {
          if (Number(p.id_tipo_permiso) !== Number(tipo.id)) {
            return false
          }
          if (idPeriodoActual && Number(p.id) === idPeriodoActual) {
            return true
          }
          return Number(p.dias_disponibles) > 0 && Number(p.saldo_activo) !== 0
        })
        return periodos.length > 0
      }
      return true
    },
    async asegurarCatalogos () {
      const anioRef = (this.catalogos && this.catalogos.anio) || new Date().getFullYear()
      await this.cargarCatalogos(anioRef)
    },
    async cargarCatalogos (anio) {
      const anioRef = anio || new Date().getFullYear()
      try {
        const params = {
          anio: anioRef,
          anio_hasta: anioRef + 1,
          id_empleado: this.user && this.user.id_empleado ? this.user.id_empleado : undefined,
        }
        // Al corregir/reenviar, el backend excluye esta solicitud del cupo mostrado
        // y fuerza el periodo ligado (sin liberar la reserva real en BD).
        if (this.isEditing && this.id_solicitud) {
          params.id_solicitud = this.id_solicitud
        }
        const response = await this.$http.get('solicitudes-permisos/obtener-catalogos', {
          params,
        })
        if (response.data && response.data.response) {
          this.catalogosLocales = Object.assign({
            tipos: [],
            periodos: [],
            inhabiles: [],
            dias_solicitados: [],
            anio: anioRef,
          }, response.data.data || {})
          this.asegurarPeriodoEdicionEnCatalogo()
        }
      } catch (error) {
        this.showSnackbar('No se pudieron cargar los catálogos.', 'error')
      }
    },
    asegurarPeriodoEdicionEnCatalogo () {
      const d = this.datos_solicitud_editar
      if (!this.isEditing || !d || !d.id_periodo_permiso_disfrute) {
        return
      }
      const idPeriodo = Number(d.id_periodo_permiso_disfrute)
      if (!idPeriodo) {
        return
      }
      const periodos = Array.isArray(this.catalogosLocales.periodos)
        ? this.catalogosLocales.periodos
        : []
      const idx = periodos.findIndex((p) => Number(p.id) === idPeriodo)
      const periodoDetalle = d.periodo || null
      const base = idx >= 0 ? { ...periodos[idx] } : {
        id: idPeriodo,
        id_tipo_permiso: Number(d.id_tipo_permiso)
          || (periodoDetalle && Number(periodoDetalle.id_tipo_permiso))
          || null,
        anio: periodoDetalle && periodoDetalle.anio != null
          ? Number(periodoDetalle.anio)
          : (d.anio_referencia ? Number(d.anio_referencia) : null),
        descripcion: (periodoDetalle && periodoDetalle.descripcion)
          || d.periodo_descripcion
          || 'Periodo de la solicitud',
        fecha_inicio: (periodoDetalle && periodoDetalle.fecha_inicio) || null,
        fecha_fin: (periodoDetalle && periodoDetalle.fecha_fin) || null,
        fecha_fin_efectiva: (periodoDetalle && periodoDetalle.fecha_fin_efectiva)
          || (periodoDetalle && periodoDetalle.fecha_fin)
          || null,
        tiene_ampliacion: periodoDetalle ? Number(periodoDetalle.tiene_ampliacion) || 0 : 0,
        dias_disponibles: 1,
        saldo_activo: 1,
      }
      base.id = Number(base.id)
      base.id_tipo_permiso = Number(base.id_tipo_permiso)
      if (Number(base.dias_disponibles) <= 0) {
        base.dias_disponibles = Math.max(1, Number(d.num_dias_habiles_solicitados) || 1)
      }
      if (Number(base.saldo_activo) === 0) {
        base.saldo_activo = 1
      }
      if (idx >= 0) {
        this.$set(this.catalogosLocales.periodos, idx, base)
      } else {
        this.catalogosLocales.periodos = periodos.concat([base])
      }
    },
    async actualizarAnioReferencia (anio) {
      const anioRef = Number(anio) || new Date().getFullYear()
      const anioPrevio = this.form.anio_referencia != null && this.form.anio_referencia !== ''
        ? Number(this.form.anio_referencia)
        : null

      if (anioPrevio === anioRef) {
        return
      }

      this.form.anio_referencia = anioRef

      if (anioPrevio !== null && anioPrevio !== anioRef && this.requierePeriodo) {
        this.form.id_periodo_permiso_disfrute = null
      }

      if (Number(this.catalogosLocales.anio) !== anioRef) {
        await this.cargarCatalogos(anioRef)
      }
    },
    async sincronizarAnioDesdeFechaInicio (fechaInicio) {
      if (!fechaInicio) {
        return
      }
      const anio = Number(String(fechaInicio).substring(0, 4))
      if (!anio || Number.isNaN(anio)) {
        return
      }
      await this.actualizarAnioReferencia(anio)
    },
    inicializarDatosEdicion () {
      if (!this.isEditing) {
        this.form = crearFormularioVacio()
        this.folioSolicitud = null
        this.aplicarZonaComision()
        return
      }

      const d = this.datos_solicitud_editar || {}
      this.isHydratingEditData = true
      this.folioSolicitud = d.folio || null
      const fechaInicio = d.fecha_inicio_disfrute
        ? String(d.fecha_inicio_disfrute).substring(0, 10)
        : ''
      this.form = {
        id_tipo_permiso: d.id_tipo_permiso ? Number(d.id_tipo_permiso) : null,
        id_periodo_permiso_disfrute: d.id_periodo_permiso_disfrute
          ? Number(d.id_periodo_permiso_disfrute)
          : null,
        anio_referencia: d.anio_referencia
          ? Number(d.anio_referencia)
          : (fechaInicio ? Number(fechaInicio.substring(0, 4)) : null),
        fecha_inicio_disfrute: fechaInicio,
        fecha_fin_disfrute: d.fecha_fin_disfrute
          ? String(d.fecha_fin_disfrute).substring(0, 10)
          : '',
        fecha_reincorporacion: d.fecha_reincorporacion
          ? String(d.fecha_reincorporacion).substring(0, 10)
          : '',
        observaciones: d.observaciones || '',
        id_zona_adscripcion: null,
        id_unidad: null,
      }
      this.aplicarZonaComision()
      this.$nextTick(() => {
        this.asegurarPeriodoEdicionEnCatalogo()
        this.isHydratingEditData = false
      })
    },
    contarDiasHabiles (fechaDesde, fechaHasta) {
      if (!fechaDesde || !fechaHasta) {
        return 0
      }
      const inicio = new Date(fechaDesde + 'T00:00:00')
      const fin = new Date(fechaHasta + 'T00:00:00')
      if (Number.isNaN(inicio.getTime()) || Number.isNaN(fin.getTime()) || fin < inicio) {
        return 0
      }

      let count = 0
      const cursor = new Date(inicio)
      while (cursor <= fin) {
        const ymd = this.formatYmd(cursor)
        if (this.esDiaHabilPermitido(ymd)) {
          count++
        }
        cursor.setDate(cursor.getDate() + 1)
      }
      return count
    },
    formatYmd (date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    esDiaHabilPermitido (ymd) {
      if (!ymd) {
        return false
      }
      if (this.setInhabiles[ymd]) {
        return false
      }
      if (this.mapDiasSolicitadosTipos[ymd]) {
        return false
      }
      const fecha = new Date(ymd + 'T00:00:00')
      if (Number.isNaN(fecha.getTime())) {
        return false
      }
      const dow = fecha.getDay()
      return dow !== 0 && dow !== 6
    },
    diasNaturalesDesdeHoy (ymd) {
      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)
      const fecha = new Date(ymd + 'T00:00:00')
      if (Number.isNaN(fecha.getTime()) || fecha <= hoy) {
        return 0
      }
      return Math.round((fecha.getTime() - hoy.getTime()) / 86400000)
    },
    tipoBloqueaDiasPegadosAInhabil () {
      const clave = this.tipoSeleccionado && this.tipoSeleccionado.clave
      return clave === 'dias_economicos' || clave === 'cuatrimestre'
    },
    diaEstaPegadoAInhabil (ymd) {
      const fecha = new Date(ymd + 'T00:00:00')
      if (Number.isNaN(fecha.getTime())) {
        return false
      }
      const antes = new Date(fecha)
      antes.setDate(antes.getDate() - 1)
      const despues = new Date(fecha)
      despues.setDate(despues.getDate() + 1)
      return Boolean(
        this.setInhabiles[this.formatYmd(antes)]
        || this.setInhabiles[this.formatYmd(despues)]
      )
    },
    esFechaDisfrutePermitida (ymd) {
      if (!this.esDiaHabilPermitido(ymd)) {
        return false
      }
      if (this.tipoBloqueaDiasPegadosAInhabil() && this.diaEstaPegadoAInhabil(ymd)) {
        return false
      }
      return true
    },
    esFechaInicioPermitida (ymd) {
      if (!this.esFechaDisfrutePermitida(ymd)) {
        return false
      }
      // 3 días naturales de anticipación para todos los tipos, salvo solicitud retroactiva
      if (this.periodoPermiteSolicitudRetroactiva) {
        return true
      }
      return this.diasNaturalesDesdeHoy(ymd) >= 3
    },
    esFechaFinPermitida (ymd) {
      return this.esFechaDisfrutePermitida(ymd)
    },
    rangoSinDiasSolicitados (fechaInicio, fechaFin) {
      if (!fechaInicio || !fechaFin) {
        return true
      }
      const inicio = new Date(fechaInicio + 'T00:00:00')
      const fin = new Date(fechaFin + 'T00:00:00')
      if (Number.isNaN(inicio.getTime()) || Number.isNaN(fin.getTime()) || fin < inicio) {
        return true
      }

      const cursor = new Date(inicio)
      while (cursor <= fin) {
        const ymd = this.formatYmd(cursor)
        if (this.mapDiasSolicitadosTipos[ymd]) {
          return false
        }
        cursor.setDate(cursor.getDate() + 1)
      }
      return true
    },
    esDiaConEventoCalendario (ymd) {
      return Boolean(this.mapInhabilesTipos[ymd] || this.mapDiasSolicitadosTipos[ymd])
    },
    colorEventoCalendario (ymd) {
      const inhabil = this.mapInhabilesTipos[ymd]
      if (inhabil === 'ley') {
        return 'inhabil-ley'
      }
      if (inhabil === 'usos_costumbres') {
        return 'inhabil-costumbres'
      }

      const tipo = this.mapDiasSolicitadosTipos[ymd]
      if (tipo === 'dias_economicos') {
        return 'solicitud-economicos'
      }
      if (tipo === 'cuatrimestre') {
        return 'solicitud-extraordinarios'
      }
      if (tipo === 'vacaciones') {
        return 'solicitud-vacaciones'
      }
      if (tipo === 'anios_servicio') {
        return 'solicitud-anios-servicio'
      }

      return 'grey'
    },
    tipoRestringeInhabiles (tipo) {
      if (!tipo) {
        return false
      }
      return tipo.clave === 'dias_economicos' || tipo.clave === 'cuatrimestre'
    },
    validarNoJuntarInhabiles (fechaInicio, fechaFin) {
      if (!fechaInicio || !fechaFin) {
        return true
      }
      const inhabiles = this.setInhabiles
      const inicio = new Date(fechaInicio + 'T00:00:00')
      const fin = new Date(fechaFin + 'T00:00:00')
      if (Number.isNaN(inicio.getTime()) || Number.isNaN(fin.getTime()) || fin < inicio) {
        return true
      }

      const cursor = new Date(inicio)
      while (cursor <= fin) {
        if (inhabiles[this.formatYmd(cursor)]) {
          return false
        }
        cursor.setDate(cursor.getDate() + 1)
      }

      const antes = new Date(inicio)
      antes.setDate(antes.getDate() - 1)
      const despues = new Date(fin)
      despues.setDate(despues.getDate() + 1)
      if (inhabiles[this.formatYmd(antes)] || inhabiles[this.formatYmd(despues)]) {
        return false
      }

      return true
    },
    buildPayload () {
      return {
        id_empleado: this.user.id_empleado,
        id_solicitud: this.id_solicitud || null,
        id_tipo_permiso: this.form.id_tipo_permiso,
        id_periodo_permiso_disfrute: this.requierePeriodo
          ? this.form.id_periodo_permiso_disfrute
          : null,
        anio_referencia: Number(this.form.anio_referencia),
        fecha_inicio_disfrute: this.form.fecha_inicio_disfrute,
        fecha_fin_disfrute: this.form.fecha_fin_disfrute,
        fecha_reincorporacion: this.form.fecha_reincorporacion,
        num_dias_habiles_solicitados: this.numDiasHabiles,
        observaciones: (this.form.observaciones || '').trim().toUpperCase() || null,
        id_zona_adscripcion: this.form.id_zona_adscripcion
          ? Number(this.form.id_zona_adscripcion)
          : null,
        id_unidad: this.form.id_unidad
          ? Number(this.form.id_unidad)
          : null,
      }
    },
    validarFormulario () {
      if (!this.form.id_tipo_permiso) {
        this.showSnackbar('Selecciona un tipo de permiso.', 'warning')
        return false
      }
      if (!this.puedeUsarTipo(this.tipoSeleccionado)) {
        const msg = this.tipoSeleccionado && this.tipoSeleccionado.clave === 'anios_servicio'
          ? 'No tienes días de años de servicio asignados para el periodo vigente.'
          : (this.tipoSeleccionado && this.tipoSeleccionado.clave === 'cuatrimestre'
            ? 'No tienes días de cuatrimestre asignados para el periodo vigente.'
            : 'No cumples la antigüedad mínima de 6 meses para este tipo de permiso.')
        this.showSnackbar(msg, 'error')
        return false
      }
      if (this.requierePeriodo && !this.form.id_periodo_permiso_disfrute) {
        this.showSnackbar('Selecciona el periodo correspondiente.', 'warning')
        return false
      }
      if (!this.form.fecha_inicio_disfrute || !this.form.fecha_fin_disfrute) {
        this.showSnackbar('Captura las fechas de disfrute.', 'warning')
        return false
      }
      if (!this.form.anio_referencia) {
        this.showSnackbar('Captura la fecha de inicio para obtener el año de referencia.', 'warning')
        return false
      }
      if (this.form.fecha_inicio_disfrute > this.form.fecha_fin_disfrute) {
        this.showSnackbar('La fecha de fin debe ser mayor o igual a la fecha de inicio.', 'error')
        return false
      }
      if (this.fechaInicioMinPeriodo
        && this.form.fecha_inicio_disfrute < this.fechaInicioMinPeriodo) {
        this.showSnackbar(
          `La fecha de inicio debe ser mayor o igual al inicio del periodo (${this.fechaInicioMinPeriodo}).`,
          'error'
        )
        return false
      }
      if (!this.periodoPermiteSolicitudRetroactiva
        && this.diasNaturalesDesdeHoy(this.form.fecha_inicio_disfrute) < 3) {
        this.showSnackbar(
          'Los permisos se solicitan con al menos 3 días naturales de anticipación, incluyendo sábado y domingo.',
          'error'
        )
        return false
      }
      if (!this.esDiaHabilPermitido(this.form.fecha_inicio_disfrute)
        || !this.esDiaHabilPermitido(this.form.fecha_fin_disfrute)) {
        this.showSnackbar(
          'Las fechas de disfrute deben ser días hábiles y no coincidir con inhábiles ni con días ya solicitados.',
          'error'
        )
        return false
      }
      if (!this.rangoSinDiasSolicitados(this.form.fecha_inicio_disfrute, this.form.fecha_fin_disfrute)) {
        this.showSnackbar(
          'El rango seleccionado incluye días ya solicitados (económicos, extraordinarios, vacaciones o años de servicio).',
          'error'
        )
        return false
      }
      if (this.tipoRestringeInhabiles(this.tipoSeleccionado)
        && !this.validarNoJuntarInhabiles(this.form.fecha_inicio_disfrute, this.form.fecha_fin_disfrute)) {
        this.showSnackbar(
          'Días económicos y días extraordinarios no pueden incluir ni estar contiguos a días inhábiles.',
          'error'
        )
        return false
      }
      if (!this.form.fecha_reincorporacion) {
        this.showSnackbar('Captura la fecha de reincorporación.', 'warning')
        return false
      }
      if (this.form.fecha_reincorporacion <= this.form.fecha_fin_disfrute) {
        this.showSnackbar(
          'La fecha de reincorporación debe ser posterior a la fecha fin de disfrute.',
          'error'
        )
        return false
      }
      if (!this.esDiaHabilPermitido(this.form.fecha_reincorporacion)) {
        this.showSnackbar(
          'La fecha de reincorporación debe ser un día hábil y no coincidir con inhábiles ni con días ya solicitados.',
          'error'
        )
        return false
      }
      if (this.numDiasHabiles <= 0) {
        this.showSnackbar('El número de días hábiles debe ser mayor a cero.', 'error')
        return false
      }
      if (this.unidadesComision.length > 1 && !this.form.id_unidad) {
        this.showSnackbar('Selecciona tu unidad.', 'warning')
        return false
      }
      if (this.actualizarCorreo) {
        const correo = (this.correoNuevo || '').trim()
        if (!correo) {
          this.showSnackbar('Captura el nuevo correo electrónico.', 'warning')
          return false
        }
        if (!this.esCorreoValido(correo)) {
          this.showSnackbar('El correo electrónico no es válido.', 'error')
          return false
        }
        if (correo.toLowerCase() === (this.correoActual || '').trim().toLowerCase()) {
          this.showSnackbar('El nuevo correo debe ser diferente al correo actual.', 'warning')
          return false
        }
      }
      return true
    },
    esCorreoValido (correo) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(correo || '').trim())
    },
    async cargarCorreoEmpleado () {
      if (this.datos_empleado && Object.prototype.hasOwnProperty.call(this.datos_empleado, 'correo')) {
        this.correoActual = this.datos_empleado.correo
          ? String(this.datos_empleado.correo).trim()
          : ''
        return
      }
      if (!this.user || !this.user.id_empleado) {
        this.correoActual = ''
        return
      }
      try {
        const response = await this.$http.get(
          'solicitudes-permisos/datos-empleado/' + this.user.id_empleado
        )
        if (response.data && response.data.response && response.data.data) {
          const correo = response.data.data.correo
          this.correoActual = correo ? String(correo).trim() : ''
          return
        }
      } catch (error) {
        this.correoActual = ''
        return
      }
      this.correoActual = ''
    },
    async actualizarCorreoEmpleado () {
      const form = new FormData()
      form.append('id_user', this.user.id_user)
      form.append('email', this.correoNuevo.trim().toLowerCase())
      const response = await this.$http.post('change-email', form)
      if (!response.data || !response.data.response) {
        throw new Error(
          (response.data && response.data.message) || 'No se pudo actualizar el correo electrónico'
        )
      }
      this.correoActual = this.correoNuevo.trim().toLowerCase()
      if (this.user) {
        this.$store.commit('setUser', {
          ...this.user,
          email: this.correoActual,
        })
      }
    },
    async enviarSolicitud (endpoint, mensajeExito) {
      const response = await this.$http.post(endpoint, this.buildPayload())
      if (!response.data || !response.data.response) {
        this.$swal({
          title: (response.data && response.data.message) || 'No se pudo procesar la solicitud',
          text: '',
          icon: 'error',
          button: 'Aceptar',
        })
        return
      }

      if (this.actualizarCorreo) {
        try {
          await this.actualizarCorreoEmpleado()
        } catch (error) {
          this.$swal({
            title: 'La solicitud se guardó, pero no se pudo actualizar el correo.',
            text: this.obtenerMensajeErrorApi(error, ''),
            icon: 'warning',
            button: 'Aceptar',
          })
          this.onRegresar(true)
          return
        }
      }

      if (this.isEditing) {
        // La corrección deja la solicitud en pendiente por firmas; falta cargar el formato firmado
        await this.$swal({
          title: 'Solicitud corregida',
          text: 'Genera el formato, fírmalo y cárgalo para enviarla a validación.',
          icon: 'info',
          button: 'Aceptar',
        })
      } else {
        this.$toasted.success(response.data.message || mensajeExito)
      }
      this.onRegresar(true)
    },
    submitRequest () {
      if (this.guardandoSolicitud || !this.validarFormulario()) {
        return
      }

      this.$swal({
        className: 'text-center',
        title: '¿Estás seguro de guardar la solicitud de permiso?',
        text: '',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        reverseButtons: true,
        buttons: ['Cancelar', 'Aceptar'],
      }).then(async (value) => {
        if (!value || this.guardandoSolicitud) {
          return
        }
        this.guardandoSolicitud = true
        try {
          await this.enviarSolicitud(
            'post-empleado-solicitud-permiso',
            'SOLICITUD GUARDADA CORRECTAMENTE'
          )
        } catch (error) {
          this.$swal({
            title: this.obtenerMensajeErrorApi(error, 'Ocurrió un problema al procesar la solicitud'),
            text: '',
            icon: 'error',
            button: 'Aceptar',
          })
        } finally {
          this.guardandoSolicitud = false
        }
      })
    },
    submitUpdateRequest () {
      if (this.guardandoSolicitud || !this.validarFormulario()) {
        return
      }

      this.$swal({
        className: 'text-center',
        title: '¿Estás seguro de guardar la corrección de la solicitud?',
        text: '',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        reverseButtons: true,
        buttons: ['Cancelar', 'Aceptar'],
      }).then(async (value) => {
        if (!value || this.guardandoSolicitud) {
          return
        }
        this.guardandoSolicitud = true
        try {
          await this.enviarSolicitud(
            'post-empleado-solicitud-permiso-editar',
            'SOLICITUD CORREGIDA'
          )
        } catch (error) {
          this.$swal({
            title: this.obtenerMensajeErrorApi(error, 'Ocurrió un problema al guardar la corrección'),
            text: '',
            icon: 'error',
            button: 'Aceptar',
          })
        } finally {
          this.guardandoSolicitud = false
        }
      })
    },
    obtenerMensajeErrorApi (error, fallback) {
      const data = error && error.response && error.response.data
      if (!data) {
        return fallback
      }
      if (typeof data === 'string' && data.trim()) {
        return data.trim()
      }
      const mensaje = data.message || data.error
      if (typeof mensaje === 'string' && mensaje.trim()) {
        return mensaje.trim()
      }
      return fallback
    },
    onRegresar (solicitudExitosa = false) {
      this.$emit('regresar', { solicitudExitosa })
    },
    showSnackbar (text, color = 'success') {
      this.snackbar.text = text
      this.snackbar.color = color
      this.snackbar.show = true
    },
    quitarFocoAlAbrir (evento) {
      if (evento && evento.target && typeof evento.target.blur === 'function') {
        evento.target.blur()
      }
    },
    aplicarZonaComision () {
      if (this.zonaGuardada) {
        this.form.id_zona_adscripcion = this.zonaGuardada.id
        this.aplicarUnidadComision()
        return
      }
      const ids = this.zonasComision.map((zona) => zona.id_zona_adscripcion)
      const actual = Number(this.form.id_zona_adscripcion) || null
      if (!(actual && ids.indexOf(actual) !== -1 && ids.length !== 1)) {
        const guardada = this.isEditing && this.datos_solicitud_editar
          ? Number(this.datos_solicitud_editar.id_zona_adscripcion) || null
          : null
        if (guardada && ids.indexOf(guardada) !== -1) {
          this.form.id_zona_adscripcion = guardada
        } else if (ids.length === 1) {
          this.form.id_zona_adscripcion = ids[0]
        } else if (!actual || ids.indexOf(actual) === -1) {
          this.form.id_zona_adscripcion = null
        }
      }
      this.aplicarUnidadComision()
    },
    aplicarUnidadComision () {
      if (this.unidadGuardada) {
        this.form.id_unidad = this.unidadGuardada.id
        this.aplicarZonaDesdeUnidad()
        return
      }
      const ids = this.unidadesComision.map((unidad) => unidad.id_unidad)
      const actual = Number(this.form.id_unidad) || null
      if (actual && ids.indexOf(actual) !== -1 && ids.length !== 1) {
        this.aplicarZonaDesdeUnidad()
        return
      }
      const guardada = this.isEditing && this.datos_solicitud_editar
        ? Number(this.datos_solicitud_editar.id_unidad) || null
        : null
      if (guardada && ids.indexOf(guardada) !== -1) {
        this.form.id_unidad = guardada
        this.aplicarZonaDesdeUnidad()
        return
      }
      if (ids.length === 1) {
        this.form.id_unidad = ids[0]
        this.aplicarZonaDesdeUnidad()
        return
      }
      if (!actual || ids.indexOf(actual) === -1) {
        this.form.id_unidad = null
      }
      this.aplicarZonaDesdeUnidad()
    },
    aplicarZonaDesdeUnidad () {
      if (this.zonaGuardada) {
        this.form.id_zona_adscripcion = this.zonaGuardada.id
        return
      }
      const idUnidad = Number(this.form.id_unidad) || null
      const unidad = this.unidadesComision.find((item) => item.id_unidad === idUnidad)
      if (unidad && unidad.id_zona_adscripcion) {
        this.form.id_zona_adscripcion = unidad.id_zona_adscripcion
        return
      }
      if (this.zonasComision.length === 1) {
        this.form.id_zona_adscripcion = this.zonasComision[0].id_zona_adscripcion
      }
    },
    limpiarCamposDisfrute () {
      this.form.anio_referencia = null
      this.form.fecha_inicio_disfrute = ''
      this.form.fecha_fin_disfrute = ''
      this.form.fecha_reincorporacion = ''
      this.form.observaciones = ''
    },
    limpiarCamposDependientesDeFechaInicio () {
      this.form.fecha_fin_disfrute = ''
      this.form.fecha_reincorporacion = ''
    },
  },
}
</script>

<style scoped>
.solicitud-permiso-disfrute {
  min-height: calc(100vh - 140px);
}

.solicitudes-permisos-loading {
  min-height: calc(118.8vh - 260px);
}

.section-card {
  border-radius: 12px;
}

.section-card__title {
  word-break: break-word;
}

.folio-info-box {
  padding: 10px 14px;
  border-radius: 8px;
  background: #f5f7fa;
  font-weight: 600;
  color: #2c3e50;
}

.campo-solo-lectura >>> input {
  color: #757575 !important;
}

.inhabiles-leyenda {
  gap: 8px;
}

.inhabil-muestra {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}

.inhabil-muestra--ley {
  background-color: #e53935;
}

.inhabil-muestra--costumbres {
  background-color: #1e88e5;
}

.inhabil-muestra--economicos {
  background-color: #ffc107;
}

.inhabil-muestra--extraordinarios {
  background-color: #ff9800;
}

.inhabil-muestra--vacaciones {
  background-color: #4caf50;
}

.inhabil-muestra--anios-servicio {
  background-color: #795548;
}
</style>

<style>
.fecha-picker-menu {
  background: #fff !important;
}

.fecha-picker-menu .v-date-picker-table .v-btn {
  overflow: visible;
}

.fecha-picker-menu .v-date-picker-table .v-btn__content {
  position: relative;
  z-index: 1;
}

.fecha-picker-menu .v-date-picker-table__events {
  top: 0 !important;
  bottom: 0 !important;
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.fecha-picker-menu .v-date-picker-table__events > div {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 36px !important;
  height: 36px !important;
  margin: 0 !important;
  border-radius: 50% !important;
  opacity: 1 !important;
}

.fecha-picker-menu .v-date-picker-table__events > div.inhabil-ley {
  background-color: rgba(229, 57, 53, 0.16) !important;
}

.fecha-picker-menu .v-date-picker-table__events > div.inhabil-costumbres {
  background-color: rgba(30, 136, 229, 0.16) !important;
}

.fecha-picker-menu .v-date-picker-table__events > div.solicitud-economicos {
  background-color: rgba(255, 193, 7, 0.28) !important;
}

.fecha-picker-menu .v-date-picker-table__events > div.solicitud-extraordinarios {
  background-color: rgba(255, 152, 0, 0.28) !important;
}

.fecha-picker-menu .v-date-picker-table__events > div.solicitud-vacaciones {
  background-color: rgba(76, 175, 80, 0.28) !important;
}

.fecha-picker-menu .v-date-picker-table__events > div.solicitud-anios-servicio {
  background-color: rgba(121, 85, 72, 0.28) !important;
}

.fecha-picker-menu .v-date-picker-table .v-btn.v-btn--disabled .v-date-picker-table__events > div.inhabil-ley,
.fecha-picker-menu .v-date-picker-table .v-btn.v-btn--disabled .v-date-picker-table__events > div.inhabil-costumbres,
.fecha-picker-menu .v-date-picker-table .v-btn.v-btn--disabled .v-date-picker-table__events > div.solicitud-economicos,
.fecha-picker-menu .v-date-picker-table .v-btn.v-btn--disabled .v-date-picker-table__events > div.solicitud-extraordinarios,
.fecha-picker-menu .v-date-picker-table .v-btn.v-btn--disabled .v-date-picker-table__events > div.solicitud-vacaciones,
.fecha-picker-menu .v-date-picker-table .v-btn.v-btn--disabled .v-date-picker-table__events > div.solicitud-anios-servicio {
  opacity: 1 !important;
}
</style>
